/// <reference path="../../TypeLite.Net4.d.ts" />
import _ from 'lodash';
import * as React from 'react';
import { ReactPlayer } from '../reactPlayer';

export interface IServiceVideoProps {
	video: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ServiceMediaModel,
	onProgress?: (playedPercenteage: number) => void,
	onStart?: () => void,
	onPause?: () => void
}

export const ServiceVideo: React.FC<IServiceVideoProps> = (props) => {
	const [started, setStarted] = React.useState(false);
	const [paused, setPaused] = React.useState(false);
	const [lastProgress, setLastProgress] = React.useState(0);
	const [width, setWidth] = React.useState(0);

	const containerRef = React.useRef<HTMLDivElement>(null);

	const onProgress = (state: { played: number, playedSeconds: number, loaded: number, loadedSeconds: number }) => {
		let progressUpdated = 0;

		if (lastProgress < 0.25 && state.played >= 0.25) {
			progressUpdated = 0.25;
		}

		if (lastProgress < 0.5 && state.played >= 0.5) {
			progressUpdated = 0.5;
		}

		if (lastProgress < 0.75 && state.played >= 0.75) {
			progressUpdated = 0.75;
		}

		if (lastProgress < 1 && state.played >= 0.99) {
			progressUpdated = 1;
		}

		if (progressUpdated > 0) {
			setLastProgress(progressUpdated);
			props.onProgress?.(progressUpdated * 100);
		}
	};

	const onStart = () => {
		if (!started) {
			setStarted(true);
			props.onStart?.();
		}
	};

	const onPause = () => {
		if (!paused) {
			setPaused(true);
			props.onPause?.();
		}
	};

	React.useEffect(() => {
		if (!containerRef.current) return;

		const resizeCallback = _.throttle<ResizeObserverCallback>((entries) => {
			const rect = entries[0].contentRect;
			setWidth(rect.width);
		}, 200);

		const resizeObserver = new ResizeObserver(resizeCallback);
		resizeObserver.observe(containerRef.current);

		return () => {
			resizeCallback.cancel();
			resizeObserver.disconnect();
		};
	}, []);

	if (!props.video) return null;

	return (
		<div ref={containerRef} className="col-xl-24 col-lg-24 col-md-24 col-md-24 col-sm-24 video-item-container position-col-reset">
			<ReactPlayer
				url={props.video.Url}
				className='react-player'
				width='100%'
				height={width ? width * 9 / 16 : undefined}
				controls={true}
				onProgress={onProgress}
				onStart={onStart}
				onPause={onPause}
			/>
			<p>{props.video.Description}</p>
		</div>
	);
}
